import type {AjaxService} from './ajax.service';

export class ClientSessionVerifierDataService {
    public static serviceName = 'clientSessionVerifierDataService';

    public static readonly ROUTE = '/session/verify';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    public async verify(botDetectionResult: BotDetectionResult): Promise<void> {
        return this.ajaxService
            .createRequest(ClientSessionVerifierDataService.ROUTE)
            .post(null, botDetectionResult);
    }
}

type BotDetectionResult = {bot: true; botKind: string;} | {bot: false;};